(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horse-mineral-checklist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mineral-checklist')) {
    class MineralChecklist extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.inputs = Array.from(this.querySelectorAll('[data-checklist-item]'));
        this.score = this.querySelector('[data-score]');
        this.scoreCopy = this.querySelector('[data-score-copy]');
        this.resultHeading = this.querySelector('[data-active-result-heading]');
        this.resultSection = this.querySelector('[data-result-section]');
        this.resultPanels = Array.from(this.querySelectorAll('[data-result-panel]'));
        this.showResultButton = this.querySelector('[data-show-result]');
        this.resetButton = this.querySelector('[data-reset]');
        const lowSetting = Number.parseInt(this.dataset.lowMax, 10) || 3;
        const midSetting = Number.parseInt(this.dataset.midMax, 10) || 7;
        this.lowMax = Math.min(lowSetting, midSetting);
        this.midMax = Math.max(lowSetting, midSetting);
        this.rememberProgress = this.dataset.remember === 'true';
        this.storageKey = this.dataset.storageKey;
        this.handleChange = this.update.bind(this);
        this.handleShowResult = this.showResult.bind(this);
        this.handleReset = this.reset.bind(this);

        this.addEventListener('change', this.handleChange);
        this.showResultButton?.addEventListener('click', this.handleShowResult);
        this.resetButton?.addEventListener('click', this.handleReset);

        this.restore();
        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleChange);
        this.showResultButton?.removeEventListener('click', this.handleShowResult);
        this.resetButton?.removeEventListener('click', this.handleReset);
        this.dataset.initialized = 'false';
      }

      getTier(count) {
        if (count <= this.lowMax) return 'low';
        if (count <= this.midMax) return 'mid';
        return 'high';
      }

      update() {
        const count = this.inputs.filter((input) => input.checked).length;
        const total = this.inputs.length;
        const tier = this.getTier(count);
        const activePanel = this.resultPanels.find((panel) => panel.dataset.resultPanel === tier);
        const activeHeading = activePanel?.dataset.heading || '';

        if (this.score) this.score.textContent = String(count);
        if (this.scoreCopy) this.scoreCopy.textContent = String(count);
        if (this.resultHeading) this.resultHeading.textContent = activeHeading;

        this.resultPanels.forEach((panel) => {
          panel.hidden = panel.dataset.resultPanel !== tier;
        });

        this.save();
      }

      showResult() {
        this.resultSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => this.resultSection?.focus({ preventScroll: true }), 450);
      }

      reset() {
        this.inputs.forEach((input) => {
          input.checked = false;
        });

        try {
          window.localStorage.removeItem(this.storageKey);
        } catch (error) {
          void error;
        }

        this.update();
        this.querySelector('.mm-checklist__form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      save() {
        if (!this.rememberProgress) return;

        const checkedIndexes = this.inputs.reduce((indexes, input, index) => {
          if (input.checked) indexes.push(index);
          return indexes;
        }, []);

        try {
          window.localStorage.setItem(this.storageKey, JSON.stringify(checkedIndexes));
        } catch (error) {
          void error;
        }
      }

      restore() {
        if (!this.rememberProgress) return;

        try {
          const saved = JSON.parse(window.localStorage.getItem(this.storageKey) || '[]');
          if (!Array.isArray(saved)) return;
          saved.forEach((index) => {
            if (this.inputs[index]) this.inputs[index].checked = true;
          });
        } catch (error) {
          void error;
        }
      }
    }

    customElements.define('mineral-checklist', MineralChecklist);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ia-accordion]').forEach(function (acc) {
      var items = acc.querySelectorAll('.ia-item');
      acc.addEventListener('click', function (e) {
        var trigger = e.target.closest('.ia-trigger');
        if (!trigger) return;
        var item = trigger.closest('.ia-item');
        var alreadyOpen = item.classList.contains('is-open');

        items.forEach(function (i) {
          i.classList.remove('is-open');
          var t = i.querySelector('.ia-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        if (!alreadyOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
